import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset'

export default createGlobalStyle`
  ${reset}    
  html {
    overflow-x:hidden;
  },
`